import { WORKER_URL } from '../config.js';
import { fetchCache } from './fetchCache.js';

// Per-action video status: 1=HD done, 2=failed, 3=upgrading, 4=low-res done
// (upgradable), 5/13=generating. A failed video (2) is treated as no video.
const characterVideoListCache = new Map();

export const fetchCharacterVideos = async (characterId, outfitId) => {
  if (!characterId || outfitId === '' || outfitId === undefined) return [];
  const cacheKey = `${characterId}:${outfitId}`;
  if (characterVideoListCache.has(cacheKey)) {
    return characterVideoListCache.get(cacheKey);
  }

  const pending = (async () => {
    try {
      const url = `${WORKER_URL}/get_character_videos?character_id=${characterId}&outfit_id=${outfitId}`;
      const data = await fetchCache.fetchJSON(url);
      return data.videos || [];
    } catch (error) {
      characterVideoListCache.delete(cacheKey);
      console.error('[spriteVideoStatus] Failed to fetch videos:', error);
      return [];
    }
  })();
  characterVideoListCache.set(cacheKey, pending);
  return pending;
};

export const getVideoBadgeText = (status) => {
  switch (status) {
    case 1: return 'HD video';
    case 3: return 'Upgrading…';
    case 4: return 'Upgrade to HD';
    case 5:
    case 13: return 'Processing…';
    default: return '';
  }
};

export const buildVideoByActionId = (videos = []) =>
  new Map(videos.map((video) => [String(video.action_id), video]));

export const hasExistingVideo = (video) => !!video && video.status !== 2;

const PLAYABLE_VIDEO_STATUSES = new Set([1, 4]);

export const isPlayableVideoStatus = (status) => PLAYABLE_VIDEO_STATUSES.has(Number(status));

export const hasPlayableCharacterVideo = async (characterId, outfitId, actionId) => {
    if (characterId == null || characterId === '' || actionId == null || actionId === '') return false;
    if (outfitId === '' || outfitId === undefined || outfitId === null) return false;
    const videos = await fetchCharacterVideos(characterId, outfitId);
    const video = buildVideoByActionId(videos).get(String(actionId));
    return isPlayableVideoStatus(video?.status);
};

export const bindSpriteGalleryNameFilter = (searchInput, grid, itemSelector = '.sprite-gallery-item') => {
  if (!searchInput || !grid) return;

  const handleFilter = () => {
    const query = String(searchInput.value || '').trim().toLowerCase();
    grid.querySelectorAll(itemSelector).forEach((item) => {
      const name = String(item.getAttribute('aria-label') || '').toLowerCase();
      item.hidden = query.length > 0 && !name.includes(query);
    });
  };

  searchInput.addEventListener('input', handleFilter);
  return handleFilter;
};
